const XML_INITIAL = `<?xml version="1.0" encoding="UTF-8"?>
<bpmn:definitions xmlns:bpmn="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:dc="http://www.omg.org/spec/DD/20100524/DC" xmlns:di="http://www.omg.org/spec/DD/20100524/DI" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" id="Definitions_1" targetNamespace="http://bpmn.io/schema/bpmn">
   <bpmn:process id="Process" isExecutable="false">
      <bpmn:startEvent id="StartEvent">
         <bpmn:outgoing>FlowInit</bpmn:outgoing>
      </bpmn:startEvent>
      <bpmn:endEvent id="EndEvent">
         <bpmn:incoming>FlowInit</bpmn:incoming>
         <bpmn:terminateEventDefinition />
      </bpmn:endEvent>
      <bpmn:sequenceFlow id="FlowInit" sourceRef="StartEvent" targetRef="EndEvent" />
   </bpmn:process>
   <bpmndi:BPMNDiagram id="BPMNDiagram">
      <bpmndi:BPMNPlane id="BPMNPlane" bpmnElement="Process">
         <bpmndi:BPMNEdge id="EdgeFlowInit" bpmnElement="FlowInit">
            <di:waypoint x="209" y="120" />
            <di:waypoint x="672" y="120" />
         </bpmndi:BPMNEdge>
         <bpmndi:BPMNShape id="ShapeStartEvent" bpmnElement="StartEvent">
            <dc:Bounds x="173" y="102" width="36" height="36" />
         </bpmndi:BPMNShape>
         <bpmndi:BPMNShape id="ShapeEndEvent" bpmnElement="EndEvent">
            <dc:Bounds x="672" y="102" width="36" height="36" />
         </bpmndi:BPMNShape>
      </bpmndi:BPMNPlane>
   </bpmndi:BPMNDiagram>
</bpmn:definitions>`;

export default XML_INITIAL;